import React, { createContext, useContext, useState, ReactNode } from 'react';

interface StreamerModeContextType {
  isStreamerMode: boolean;
  toggleStreamerMode: () => void;
}

const StreamerModeContext = createContext<StreamerModeContextType | undefined>(undefined);

export const useStreamerMode = () => {
  const context = useContext(StreamerModeContext);
  if (context === undefined) {
    throw new Error('useStreamerMode must be used within a StreamerModeProvider');
  }
  return context;
};

interface StreamerModeProviderProps {
  children: ReactNode;
}

export const StreamerModeProvider: React.FC<StreamerModeProviderProps> = ({ children }) => {
  const [isStreamerMode, setIsStreamerMode] = useState(() => {
    // Сохраняем состояние в localStorage
    const saved = localStorage.getItem('streamer_mode');
    return saved ? JSON.parse(saved) : false;
  });

  const toggleStreamerMode = () => {
    const newMode = !isStreamerMode;
    setIsStreamerMode(newMode);
    localStorage.setItem('streamer_mode', JSON.stringify(newMode));
  };

  const value: StreamerModeContextType = {
    isStreamerMode,
    toggleStreamerMode,
  };

  return (
    <StreamerModeContext.Provider value={value}>
      {children}
    </StreamerModeContext.Provider>
  );
};

export default StreamerModeProvider;